module.exports = __webpack_public_path__ + "img/40_38_064_170.3d6dad9d.jpg";